import React, { useState, useEffect } from "react";
import SiteWrapper from "../../../SiteWrapper.react";
import Select from "react-select";

import { MenuReportesGenerales } from "./MenuReportesGenerales.react";
import { ContentReportesGenerales } from "./ContentReportesGenerales.react";
import { Paginator } from "./Paginator.react";
import { ExportarReportesGenerales } from "./ExportarReportesGenerales.react";
import { TruckLoader } from "./loaderTruck/TruckLoader";

const ReportesGeneralesPage = () => {
	//Variables check loading y error
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const loadingCount = React.useRef(0);
	const [progreso, setProgreso] = useState(null);

	const setLoadingTracked = (value) => {
		if (value) {
			loadingCount.current++;
			setLoading(true);
		} else {
			loadingCount.current = Math.max(0, loadingCount.current - 1);
			if (loadingCount.current === 0) {
				setLoading(false);
			}
		}
	};
	const [data, setData] = useState();
	const [opciones, setOpciones] = useState();
	const [sinColumnas, setSinColumnas] = useState([]);

	return (
		<SiteWrapper>
			<div className="container">
				<MenuReportesGenerales
					setLoading={setLoadingTracked}
					setError={setError}
					setData={setData}
					setOpciones={setOpciones}
					setSinColumnas={setSinColumnas}
				/>
				{data && data.content && data.content.length > 0 ? (
					<ExportarReportesGenerales
						total={data.totalElements}
						opciones={opciones}
						sinColumnas={sinColumnas}
						setLoading={setLoadingTracked}
						setError={setError}
						setProgreso={setProgreso}
					/>
				) : null}
				<ContentReportesGenerales
					data={data}
					sinColumnas={sinColumnas}
					opciones={opciones}
				/>
				{data && data.content && data.content.length > 0 ? (
					<Paginator
						data={data}
						setData={setData}
						setLoading={setLoadingTracked}
						setError={setError}
						opciones={opciones}
					/>
				) : null}
				{loading ? <TruckLoader progreso={progreso} /> : null}
			</div>
		</SiteWrapper>
	);
};

export default ReportesGeneralesPage;
